import { CobranzasAxios, COMPANY } from './config'

export const getVouchers = async (body) => {
  const res = await CobranzasAxios.post(`/voucher/${COMPANY}`, body)
  return res.data
}

export const getVouchersById = async (id) => {
  const res = await CobranzasAxios.get(`/voucher/${id}`)
  return res.data
}

export const putVouchers = async (body, serieId) => {
  const res = await CobranzasAxios.put(`/voucher/pay/${serieId}`, body)
  return res.data
}

export const deleteVouchers = async (voucherId) => {
  const res = await CobranzasAxios.delete(`/voucher/${voucherId}`)
  return res.data
}

export const getVouchersPaidByRange = async (data) => {
  const res = await CobranzasAxios.post(`/voucher/paid/${COMPANY}`, data)
  return res.data
}
